import styled from "styled-components";
import { animated } from "@react-spring/web";

export const ScrolledDeck = styled.div`
  display: flex;
  gap: 16px;
  overflow-x: scroll;
  padding-bottom: 16px;
`;

export const BoardLeftActionWrapper = styled.div`
  margin-top: auto;
  /* position: absolute; */
  /* left: 16px;
  bottom: 16px; */
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px;
  /* align-items: flex-start; */
  z-index: 2;
  border-top: 1px solid rgba(200, 215, 245, 0.05);
`;

export const MuteButton = styled.button`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  padding: 8px;

  font-family: var(--font-family-golos), sans-serif;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;

  background: #24274680;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;

  transition: all 0.5s ease, transform 0.1s ease-in-out;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.7;
    transform: scale(0.98);
  }
`;

export const PayoutLabel = styled.div`
  position: absolute;
  top: -24px;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  align-items: center;
  transform: translateY(-100%);
  background: #01192e;
  padding: 8px;
  border-radius: 8px;
  .text {
    font-size: 12px;
    padding: 4px 8px;
    background: #d2eaff0d;
    color: #d2eaff;
    border-radius: 10px;
  }

  display: none;

  @media (max-width: 1024px) {
    display: flex;
  }
`;

export const StaticDeck = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  pointer-events: none;
  z-index: 2;
  border-radius: 8px;

  &::after {
    border-radius: 8px;
    content: "";
    z-index: 1;
    position: absolute;
    inset: 0;
    box-shadow: 1px 1px 1px 0px rgba(25, 29, 44, 0.5), 2px 1px 1px 0px #d9e4fd,
      3px 2px 1px 0px rgba(25, 29, 44, 0.5), 4px 2px 1px 0px #92a2c6,
      5px 3px 1px 0px rgba(25, 29, 44, 0.5), 6px 3px 1px 0px #92a2c6,
      7px 4px 1px 0px rgba(25, 29, 44, 0.5), 8px 4px 1px 0px #92a2c6;
  }
`;

export const CardsGroups = styled.div`
  flex-grow: 1;
  width: 100%;
  display: flex;
  gap: 16px;
  justify-content: space-around;
  align-items: stretch;
`;

export const labelStatusColors = {
  WIN: "#4EA031",
  LOSS: "#D11A39",
  DRAW: "#F5BC5F",
  default: "#2A3046",
  highlight: "#2A3046",
};

export const labelStatusBorderColors = {
  WIN: "#29770E",
  LOSS: "#5E0A18",
  DRAW: "#F2C94C",
  default: "#2A3046",
  highlight: "#00B2FF",
};

export const ValueLabel = styled.div`
  /* background: #2A3046; */
  border-radius: 60px;
  padding: 8px 16px;
  color: var(--daylight-daylight-main, #d5e0f5);
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 14px;
  background-color: var(--label-color, ${labelStatusColors.default});
  border: 2px solid var(--label-border-color);
  /* box-shadow:  0px 0px 0px 2px #D5E0F526 inset; */

  svg {
    width: 16px;
    height: 16px;
    /* color inherited by parent color */
  }

  margin-top: auto;

  @media (max-width: 1024px) {
    padding: 8px 16px;
    font-size: 16px;
    line-height: 16px;
  }
`;

export const InsuranceStatusTip = styled.div`
  background: ${labelStatusColors.WIN};
  color: black;
  align-self: center;

  display: flex;
  align-items: center;
  padding: 1px 1px;
  border-radius: 12px;

  text-transform: uppercase;
  font-weight: 600;

  .text {
    border-radius: 10px 0 0 10px;
    background: #000;
    color: ${labelStatusColors.WIN};
    padding: 6px 10px;
    margin: 1px;
  }
  .value {
    padding: 6px 10px;
    font-size: 18px;
    line-height: 18px;
    color: #000;
  }
`;
// HEREWO
export const BoardLayout = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 56px;
  padding: 32px 16px 32px;
  background: transparent;
  height: 100%;
  overflow: hidden;
  position: relative;
  background-size: 100%;
  background-repeat: no-repeat;

  @media (max-width: 1024px) {
    padding: 32px 16px 32px;
  }
`;

export const CardsGrid = styled(animated.div)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* background: #4f4e4e; */
  /* grid-template-columns: repeat(auto-fit, 100px); */
  /* padding: 8px; */
  gap: 8px;
  min-height: 120px;
  /* transition: width linear 1s; */

  @media (max-width: 1024px) {
    min-height: 90px;
  }
`;

export const cardStatusColors = {
  WIN: "#4EA031",
  LOSS: "#D11A39",
  DRAW: "#F5BC5F",
  default: "#BBCAEB",
  highlight: "#00B2FF",
};

export const CardBack = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: var(--card-radius);
  /* padding: var(--card-p); */
  display: flex;
  justify-content: center;
  align-items: center;
  will-change: transform;

  background: linear-gradient(180deg, rgba(243, 247, 255, 1) 0%, rgba(218, 227, 249, 1) 72%);
  box-shadow: 0px 2px 0px 0px #323951;
`;

export const CardFront = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(243, 247, 255, 1) 0%, rgba(218, 227, 249, 1) 72%);
  padding: var(--card-p);
  position: absolute;

  border-radius: var(--card-radius);

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-family: var(--font-family-golos);
  border: 2px solid var(--front-border);
  box-shadow: 0px 2px 0px 0px #323951;
  backface-visibility: hidden;
  will-change: transform;

  .name {
    font-family: var(--font-family-exo);
    font-style: italic;
    font-weight: 800;
    z-index: 1;
    font-size: var(--sign-size);
    line-height: var(--sign-size);
  }

  .spade,
  .club {
    color: #1d2234;
  }

  .diamond,
  .heart {
    /* background: linear-gradient(180deg, #f52121 0%, #b00 60.69%);
    background-clip: text; */
    color: #e44d66;
  }

  .icon {
    position: absolute;
    inset: 0;
    /* width: var(--icon-size);
    height: var(--icon-size); */
    svg {
      width: 100%;
      height: 100%;
    }
  }

  .left {
    align-self: flex-start;
  }
  .right {
    align-self: flex-end;
  }
`;

export const Card = styled.div<{
  isFlipped: boolean;
  color?: "WIN" | "LOSS" | "DRAW" | "default" | "highlight";
}>`
  --card-size: 80px;
  --icon-size: 60px;
  --sign-size: 20px;
  --card-radius: 8px;

  --card-p: 6px;

  will-change: transform;

  aspect-ratio: 1/1.5;
  width: var(--card-size);
  position: relative;
  perspective: 50rem;
  user-select: none;

  @media (max-width: 1024px) {
    --card-size: 60px;
    --icon-size: 30px;
    --sign-size: 18px;

    --card-radius: 6px;

    --card-p: 2px;
  }
  @media (max-width: 600px) {
    --card-size: 45px;
    --icon-size: 30px;
    --sign-size: 12px;

    --card-radius: 4px;

    --card-p: 4px;
  }

  /* transition: all 300ms; */

  .inner {
    will-change: transform;
    position: relative;
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    transition: transform 200ms ease-in-out;
    transform: ${({ isFlipped }) => (isFlipped ? "rotateY(180deg)" : "rotateY(0deg)")};
  }

  ${CardBack} {
    transform: rotateY(180deg);
    transition: transform 200ms ease-in-out;
    backface-visibility: hidden;
  }
`;

export const CardGroup = styled.div<{
  statusColor?: "WIN" | "LOSS" | "DRAW" | "default" | "highlight";
  delay: number;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1;

  --card-size: 100px;

  --front-border: ${({ statusColor }) =>
    cardStatusColors[statusColor ?? "default"] ?? cardStatusColors.highlight};
  --label-color: ${({ statusColor }) =>
    labelStatusColors[statusColor ?? "default"] ?? labelStatusColors.default};
  --label-border-color: ${({ statusColor }) =>
    labelStatusBorderColors[statusColor ?? "default"] ?? labelStatusBorderColors.default};

  ${CardFront} {
    transition: border-color ease-in-out 300ms ${({ delay }) => delay ?? 1000}ms;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      z-index: 2;
      border-radius: calc(var(--card-radius) - 2px);
      box-shadow: 0px 0px 0px 1px #000 inset;
    }
  }

  ${ValueLabel} {
    transition: color ease-in-out 300ms ${({ delay }) => delay ?? 1000}ms;
  }

  .arrow-icon {
    /* width: 32px;
    height: 32px; */
    border: 1px solid;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: ${({ statusColor }) =>
      cardStatusColors[statusColor ?? "default"] ?? cardStatusColors.highlight};
    background-color: rgba(0, 178, 255, 0.05);
    box-shadow: 0px 0px 0px 3px rgba(0, 0, 0, 0.25) inset;
    .direction-icon {
      width: 16px;
      height: 16px;
    }
  }

  .direction-icon {
    /* color: ${({ statusColor }) =>
      cardStatusColors[statusColor ?? "default"] ?? cardStatusColors.highlight}; */

    path {
      fill-opacity: 1;
    }
  }
`;
